import { Component, ElementRef, ViewChild } from "@angular/core";
import { SharedService } from "../shared/service";
import { AuthService } from "../shared/auth.service";
import { toCredentialsForm } from "../forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Credentials } from "../types";

@Component({
  templateUrl: './login.content.html'
})
export class LoginContent {

  @ViewChild('name') private elementRef: ElementRef;

  constructor(private route: ActivatedRoute, private authService: AuthService, public shared: SharedService, private router: Router) {

  }

  public ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

  form = toCredentialsForm({ name: '', password: '' });

  async submit() {
    try {

      const authInfo = await this.authService.logIn(this.form.value as Credentials);
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      this.router.navigate([returnUrl]);
      this.shared.notifySuccess(this.shared.res['#Logged in'], this.shared.res['#Logged in as {{name}}']({ name: authInfo.userName }));
    } catch {
      this.shared.notifyError(this.shared.res['#Log in failed'], this.shared.res['#Log in failed']);
    }
  }
}
